import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { useAppointmentUserId } from '@store/appointment/selectors';
import { notifyBasketUpdated } from '@utils/queries/appointment';

const useSyncAppointment = () => {
  const { isSyncedAppointment, appointment } = useAppointmentContext();
  const [sendNotifyBasketUpdated] = useMutation(notifyBasketUpdated);
  const userId = useAppointmentUserId();

  const basketUpdated = useCallback(() => {
    if (
      appointment &&
      isSyncedAppointment &&
      appointment.controller.id == userId
    ) {
      sendNotifyBasketUpdated({ variables: { id: appointment.id } });
    }
  }, [isSyncedAppointment, appointment, sendNotifyBasketUpdated, userId]);

  return {
    notifyBasketUpdated: basketUpdated,
  };
};

export { useSyncAppointment };
